import { render } from "./IndukJantan.vue?vue&type=template&id=1f74d0da"
import script from "./IndukJantan.vue?vue&type=script&lang=js"
export * from "./IndukJantan.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__